import Stack from '@mui/material/Stack';
import Container from '@mui/material/Container';


// ----------------------------------------------------------------------

type Props = {
  children: React.ReactNode;
};

export default function CompactLayout({ children }: Props) {
  return (
    <Container component="main">
        <Stack
          sx={{
            m: 'auto',
            // maxWidth: 400,
            // maxHeight: '80vh',
            // textAlign: 'center',
            // justifyContent: 'center',
          }}
        >
          {children}
        </Stack>
      </Container>
  );
}
